export enum PoiCategory {
  GENERIC = 'GENERIC',
  ACCOMMODATION = 'ACCOMMODATION',
  LANDMARK = 'LANDMARK',
  VISTAPOINT = 'VISTAPOINT',
  PHOTOOPPORTUNITY = 'PHOTOOPPORTUNITY',
  ACTIVITY_SHOPPING = 'ACTIVITY_SHOPPING',
  ACTIVITY_NATURE = 'ACTIVITY_NATURE',
  ACTIVITY_WILDLIFE = 'ACTIVITY_WILDLIFE',
  ACTIVITY_WALKING = 'ACTIVITY_WALKING',
  ACTIVITY_SPORT = 'ACTIVITY_SPORT',
  ACTIVITY_WINTERSPORTS = 'ACTIVITY_WINTERSPORTS',
  ACTIVITY_MUSIC = 'ACTIVITY_MUSIC',
  ACTIVITY_CULTURE = 'ACTIVITY_CULTURE',
  ACTIVITY_MUSEUM = 'ACTIVITY_MUSEUM',
  ACTIVITY_EVENT = 'ACTIVITY_EVENT',
  ACTIVITY_DRIVE = 'ACTIVITY_DRIVE',
  ACTIVITY_RELAX = 'ACTIVITY_RELAX',
  ACTIVITY_SPA = 'ACTIVITY_SPA',
  GEOGRAPHY_CAPITAL = 'GEOGRAPHY_CAPITAL',
  GEOGRAPHY_REGION = 'GEOGRAPHY_REGION',
  GEOGRAPHY_CITY = 'GEOGRAPHY_CITY',
  CULINARY_FOOD = 'CULINARY_FOOD',
  CULINARY_COFFEE = 'CULINARY_COFFEE',
  CULINARY_BAR = 'CULINARY_BAR',
  CULINARY_PUB = 'CULINARY_PUB',
  CULINARY_NIGHTLIFE = 'CULINARY_NIGHTLIFE',
  TRANSPORTATION_TRAIN = 'TRANSPORTATION_TRAIN',
  TRANSPORTATION_PLANE = 'TRANSPORTATION_PLANE',
  TRANSPORTATION_CAR = 'TRANSPORTATION_CAR',
  TRANSPORTATION_BUS = 'TRANSPORTATION_BUS',
  TRANSPORTATION_SHIP = 'TRANSPORTATION_SHIP',
  TRANSPORTATION_MOTORCYCLE = 'TRANSPORTATION_MOTORCYCLE',
  TRANSPORTATION_BICYCLE = 'TRANSPORTATION_BICYCLE'
}

export enum PoiCategoryGroup {
  GENERAL = 'GENERAL',
  ACTIVITY = 'ACTIVITY',
  GEOGRAPHY = 'GEOGRAPHY',
  CULINARY = 'CULINARY',
  TRANSPORTATION = 'TRANSPORTATION'
}
